
import { Component, Input, OnChanges } from '@angular/core';
import { argbFromHex, hexFromArgb, TonalPalette } from '@material/material-color-utilities';

@Component({
    selector: 'app-color-palette',
    templateUrl: './color-palette.component.html',
    styleUrls: ['./color-palette.component.scss'],
    imports: []
})
export class ColorPaletteComponent implements OnChanges {
    @Input() color: string = '#000000';
    @Input() label: string = 'Palette';

    public tonesList = [100, 99, 98, 95, 90, 80, 70, 60, 50, 40, 35, 30, 25, 20, 15, 10, 5, 0];
    public palette: Array<{ tone: number; hex: string }> = [];
    public originalColorIdx: number = -1;

    ngOnChanges(): void {
        this.generatePalette();
    }

    generatePalette(): void {
        const tonal = TonalPalette.fromInt(argbFromHex(this.color));
        const generatedPalette: Array<{ tone: number; hex: string }> = this.tonesList.map((tone) => ({
            tone,
            hex: hexFromArgb(tonal.tone(tone)),
        }));

        const originalHex = this.color.startsWith('#') ? this.color.toLowerCase() : `#${this.color.toLowerCase()}`;
        let minDistance = Number.MAX_VALUE;
        let closestIdx = -1;
        for (let i = 0; i < generatedPalette.length; i++) {
            const candidate = generatedPalette[i].hex.toLowerCase();
            const rgb1 = [
                parseInt(originalHex.slice(1, 3), 16),
                parseInt(originalHex.slice(3, 5), 16),
                parseInt(originalHex.slice(5, 7), 16),
            ];
            const rgb2 = [
                parseInt(candidate.slice(1, 3), 16),
                parseInt(candidate.slice(3, 5), 16),
                parseInt(candidate.slice(5, 7), 16),
            ];
            const dist = Math.sqrt(
                Math.pow(rgb1[0] - rgb2[0], 2) + Math.pow(rgb1[1] - rgb2[1], 2) + Math.pow(rgb1[2] - rgb2[2], 2)
            );
            if (dist < minDistance) {
                minDistance = dist;
                closestIdx = i;
            }
        }
        if (closestIdx !== -1) {
            generatedPalette[closestIdx].hex = originalHex;
            this.originalColorIdx = closestIdx;
        } else {
            this.originalColorIdx = -1;
        }
        this.palette = generatedPalette;
    }
}
